import { z } from 'zod'

import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import airports from '../../Resources/airports.json'

const language = cap.language.state || 'IT'
const t = translations[language]

const MSG = t.gfCampoObbligatorio

export const isEmpty = (v) => !v

export const required = (msg = MSG) => z.any().refine((v) => !isEmpty(v), msg)

export const optional = () => z.any().optional()

export const airportRequired = (msg = MSG, options = airports) =>
  z.any().superRefine((v, ctx) => {
    if (isEmpty(v)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: msg })
      return
    }
    if (!options?.find(({ value }) => value === v)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: msg })
    }
  })
